<template>
  <div :id="accordionName" class="collapse " ref="collapseContainer" v-bind:class="{ 'expanded' : susactive, 'collapse-active' : collapsed }" v-if="!hideUnavailableFacets">
   
    <div
      class="collapse__content"
      v-bind:id="id"
      v-bind:class="{ 'collapse__content--collapsed': collapsed }"
    >
      <slot name="content"></slot>
    </div>
    <div
      class="click-overlay"
      @click="overlayClick"
      v-if="isClickOverlayEnabled & collapsed"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'collapse',
  props: {
    expanded: { require: false, default: false },
    productPage: { type: Boolean, require: false, default: false },
    filterPage: { type: Boolean, require: false, default: false },
    isClickOverlayEnabled: { require: false, default: false },
    tagging: { require: false },
    sustainabilitystatus: { type: Object, required: false, default: false },
    collapseIcon: { type: String, require: false },
    accordionName: {type: String, require: false},
	titleText: {type: String, require: false}
  },
  data() {
    return {
      collapsed: true,
      hideUnavailableFacets: false,
      susactive: false,
      id: `collapse${Math.floor(Math.random() * 1000000) + 1}`,
      pdpstickybuynowactive: false,
      payload: false
    };
  },
  computed: {
    collapseSlotsCollection() {
      return this.$slots.title[0].children[0].text;
    }
  },
  methods: {
    toggleCollapse() {
      if (this.productPage && window.innerWidth < 767) {
        Array.prototype.forEach.call(this.$parent.$children, item => {
          item.collapsed = false;
          if (item.$options.name === 'sustainability') {
            item.$children[item.$children.length - 1].collapsed = false;
          }
        });
        if (this.$parent.$parent.$el.classList.contains('collapse-list')) {
          Array.prototype.forEach.call(this.$parent.$parent.$children, item => {
            item.collapsed = false;
          });
        }
        if (!this.$el.classList.contains('collapse-active')) {
          this.collapsed = !this.collapsed;
        }
        let collapseOffsetTop =
          document.querySelector('.pdp-collapse').parentElement.offsetTop -
          (this.pdpstickybuynowactive ? 160 : 90);
        window.scrollTo({ top: collapseOffsetTop, behavior: 'smooth' });
      }
      if (this.filterPage && this.$parent.$parent.$options.name === 'filters') {
        Array.prototype.forEach.call(this.$parent.$parent.$children, item => {
          if (item.$children.length !== 0) {
            if (item.$children[0].$options.name === 'collapse' && item.$children[0].collapsed) {
              item.$children[0].collapsed = false;
            }
          }
        });
        if (!this.$el.classList.contains('collapse-active')) {
          this.collapsed = !this.collapsed;
        }
      }
      if (!this.productPage && !this.filterPage) {
        this.collapsed = !this.collapsed;
      }
      var target = this.collapsed ? `close-${this.id}` : `toggle-${this.id}`;
      this.$refs[target].focus();
    },
    overlayClick() {
      this.collapsed = false;
    },
    triggerGA() {
      if (this.tagging !== undefined) {
        try {
          window.dataLayer.push(this.tagging);
        } catch (error) {
          console.warn(error);
        }
      }
    }
  },
  mounted() {
    if (this.sustainabilitystatus && this.sustainabilitystatus.active && (this.sustainabilitystatus.active === 'True' || this.sustainabilitystatus.active) && !this.productPage) {
      this.susactive = true;
    }
    if (this.accordionName && window.location.hash.includes(this.accordionName)){
      this.toggleCollapse()
    } else {
      if (this.expanded) {
        this.toggleCollapse();
      }
      this.$nextTick(function() {
        if(this.$refs.collapseContainer && this.$refs.collapseContainer.classList.contains('expanded')){
            this.toggleCollapse();
        }        
      });
    }
    if (window.eventBus) {
      window.eventBus.$on('pdp-mobile-collapse', payload => {
        this.pdpstickybuynowactive = payload;
      });
    }
  }
};
</script>

<style lang="scss" src="./collapse.scss"></style>